//Fetch reports
export const FETCHING_DRIVERS = 'relocations/FETCHING_DRIVERS';
export const FETCH_DRIVERS = 'relocations/FETCH_DRIVERS';
export const FETCH_DRIVERS_SUCCESS = 'relocations/FETCH_DRIVERS_SUCCESS';

// Fetch vechicles
export const FETCHING_VEHICLES = 'relocations/FETCHING_VEHICLES';
export const FETCH_VEHICLES_SUCCESS = 'relocations/FETCH_VEHICLES_SUCCESS';
export const ADD_MORE_VEHICLES_SUCCESS =
  'relocations/ADD_MORE_VEHICLES_SUCCESS';

export const FETCH_VEHICLE_DETAILS = 'relocations/FETCH_VEHICLE_DETAILS';
export const FETCH_VEHICLE_COSTCENTERLIST =
  'relocations/FETCH_VEHICLE_COSTCENTERLIST';

export type Action =
  | { type: FETCHING_DRIVERS }
  | { type: FETCH_DRIVERS_SUCCESS, data: Array<Object> }
  | { type: FETCHING_VEHICLES }
  | { type: FETCH_VEHICLES_SUCCESS, data: Array<Object> }
  | { type: FETCH_VEHICLE_DETAILS }
  | { type: FETCH_VEHICLE_COSTCENTERLIST }
  | { type: ADD_MORE_VEHICLES_SUCCESS, data: Array<Object> };



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/action-types.js